import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useLanguage } from "../../store/LanguageContext";

export const NAV_ITEMS = [
  { id: "home",      to: "/",           label: "Home",      n: "01" },
  { id: "about",     to: "/about",      label: "About",     n: "02" },
  { id: "services",  to: "/services",   label: "Services",  n: "03" },
  { id: "portfolio", to: "/portofolio", label: "Portfolio", n: "04" },
  { id: "journal",   to: "/journal",    label: "Journal",   n: "05" },
  { id: "contact",   to: "/contact",    label: "Contact",   n: "06" },
];

export function TopNav() {
  const { language, setLanguage } = useLanguage();
  const langs = ["EN", "FR", "RU"];
  return (
    <nav className="ed-nav">
      <Link to="/" className="ed-logo">
        <span className="dot"></span>CitiBatiment
      </Link>
      <div className="ed-links">
        {NAV_ITEMS.map((it) => (
          <NavLink
            key={it.id}
            to={it.to}
            end={it.to === "/"}
            className={({ isActive }) => (isActive ? "act" : "")}>
            <span className="n">{it.n}</span>
            {it.label}
          </NavLink>
        ))}
      </div>
      <div className="ed-nav-r">
        <span className="ed-pulse"><span className="d"></span>Booking Q3 2026</span>
        <span className="ed-lang" role="group" aria-label="Language">
          {langs.map((code, i) => (
            <React.Fragment key={code}>
              <span
                className={language === code ? "sel" : ""}
                onClick={() => setLanguage(code)}
                style={{ cursor: "pointer" }}>
                {code}
              </span>
              {i < langs.length - 1 ? <span aria-hidden="true">·</span> : null}
            </React.Fragment>
          ))}
        </span>
      </div>
    </nav>
  );
}

export function VerticalStamp({ left = "Est. 2020 — Cannes, FR · 43.5528° N · 7.0174° E" }) {
  return (
    <div className="ed-stamp">
      <span>{left}</span>
    </div>
  );
}

export function PageHero({ eyebrow, title, lede, meta }) {
  return (
    <header className="ed-hero">
      <div className="eyebrow"><span className="bar"></span>{eyebrow}</div>
      <h1>{title}</h1>
      {lede ? <p className="lede">{lede}</p> : null}
      {meta ? (
        <div className="meta">
          {meta.map((m, i) => <div key={i} className="row">{m}</div>)}
        </div>
      ) : null}
    </header>
  );
}

export function Eyebrow({ children, clay }) {
  return (
    <span className="ed-eyebrow">
      <span className="bar"></span>
      <span className={clay ? "clay" : ""}>{children}</span>
    </span>
  );
}

export function PrimaryBtn({ children, onClick, type = "button", style, disabled }) {
  return (
    <button className="ed-btn" type={type} onClick={onClick} style={style} disabled={disabled}>
      {children} <span className="arr">→</span>
    </button>
  );
}

export function GhostBtn({ children, onClick }) {
  return <button className="ed-ghost" onClick={onClick}>{children}</button>;
}

export function ArrowLink({ children, onClick, to }) {
  if (to) {
    return (
      <Link className="ed-link" to={to}>
        {children} <span style={{ fontSize: 11 }}>→</span>
      </Link>
    );
  }
  return (
    <a className="ed-link" onClick={onClick}>
      {children} <span style={{ fontSize: 11 }}>→</span>
    </a>
  );
}

export function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="ed-marquee">
      <div className="ed-marquee-inner">
        {doubled.map((t, i) => <span key={i}>{t}</span>)}
      </div>
    </div>
  );
}

export function SectionHead({ num, eyebrow, title, right }) {
  return (
    <div className="ed-section-head">
      <div>
        <div className="num">{num} — {eyebrow}</div>
        <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
      </div>
      {right ? <div className="h2-r">{right}</div> : <div></div>}
    </div>
  );
}

export function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="ed-foot">
      <div className="ed-foot-grid">
        <div>
          <div className="cap">— Get in touch</div>
          <h3>Let's begin the <em>conversation</em>.</h3>
          <div style={{ marginTop: 24 }}>
            <button
              className="ed-btn"
              onClick={() => navigate("/contact")}
              style={{ background: "var(--clay)", color: "var(--paper)" }}>
              Start a project{" "}
              <span className="arr" style={{ background: "var(--paper)", color: "var(--clay)" }}>→</span>
            </button>
          </div>
        </div>
        <div>
          <div className="cap">— Studio</div>
          <div className="addr">
            <strong>CitiBatiment</strong><br />
            12 rue d'Antibes<br />
            06400 Cannes, France<br />
            <br />
            +33 6 18 24 32 11<br />
            info@citibatiment.com
          </div>
        </div>
        <div>
          <div className="cap">— Navigate</div>
          <ul>
            {NAV_ITEMS.map((it) => (
              <li key={it.id} onClick={() => navigate(it.to)}>{it.label}</li>
            ))}
          </ul>
        </div>
        <div>
          <div className="cap">— Elsewhere</div>
          <ul>
            <li>
              <a
                href="https://www.instagram.com/citibatiment/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit" }}>
                Instagram ↗
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/citibatiment"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit" }}>
                Facebook ↗
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="ed-foot-bot">
        <span className="mark">CitiBatiment<em style={{ fontStyle: "italic" }}>.</em></span>
        <span>© 2020 — 2026 · Interior renovation, Côte d'Azur</span>
        <span>Built quietly · Finished precisely</span>
      </div>
    </footer>
  );
}
